import { SVGAssets } from '@business/assets/vectors';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { setCommonState } from '@ports/common/commonStateSlice';
import { routePaths } from '@utils/constants/routePaths';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

interface CreateOptionsProps {
  onCreateFolder?: () => void;
  onUploadPhoto?: () => void;
}

export const CreateOptions: FC<CreateOptionsProps> = ({
  onCreateFolder,
  onUploadPhoto
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <>
      <div className="absolute top-full mt-2 left-0 bg-white shadow-lg rounded-lg py-2 w-[12rem] z-10 border border-gray-200">
        <div
          className="flex items-center gap-3 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors"
          onClick={onCreateFolder}>
          <SVGAssets.Folder className="w-5 h-5" />
          <span className="text-sm font-medium text-[#353535]">
            {t('photosPage.createFolder')}
          </span>
        </div>
        <div
          className="flex items-center gap-3 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors"
          onClick={onUploadPhoto}>
          <SVGAssets.UploadIcon className="w-5 h-5 text-[#353535]" />
          <span className="text-sm font-medium text-[#353535]">
            {t('uploadPhoto')}
          </span>
        </div>
        <div
          className="flex items-center gap-3 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors"
          onClick={() => {
            dispatch(setCommonState({ isFromPhoto: true }));
            navigate(routePaths.TakeAPhoto);
          }}>
          <SVGAssets.TakePicIcon className="w-5 h-5 text-[#353535]" />
          <span className="text-sm font-medium text-[#353535]">
            {t('photosPage.openCamera')}
          </span>
        </div>
      </div>
    </>
  );
};
